import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';

const HurtingMyself: FunctionComponent = () => {
  return (
    <Box className="py-8">
      <Typography variant="body1">
        Learning to process your feelings after sexual assault isn't easy for anyone, and it's common to have thoughts about hurting yourself. Although dealing with these thoughts can feel isolating,
        you do not have to deal with them alone. Help is available.
      </Typography>
      <Typography variant="body1" className="font-bold pt-4">
        Why do I feel this way?
      </Typography>
      <Typography variant="body1">
        You are not alone. Self-harm and suicide are preventable, and these thoughts aren't permanent. If you are thinking about harming yourself, there are resources to give you the support you need
        to get through this tough time. Remember, you are strong and help is out there.
        <br />
        <br />
        It's important to know that many people think about self-harm or suicide at one time or another in their lives. If you are having these thoughts, it may mean you are in crisis and need
        support.
      </Typography>

      <Typography variant="body1" className="font-bold pt-4">
        Where can I find help and learn more?
      </Typography>
      <Typography variant="body1">
        <ul className="rhs-hotlines-list">
          <li>
            National Suicide Prevention Lifeline. Call the Lifeline at 800.273.TALK (8255), or chat online using the Lifeline Crisis Chat. Both are open 24/7. The Lifeline is not an anonymous service
            and some personal information may be collected and used if the caller is in danger, such as an IP address or the caller's telephone number. If you are concerned about privacy, please
            review the organization's policies before using either service.
          </li>
          <li>Veterans Crisis Line. If you are a veteran, you can call the Veterans Crisis Line at 800.273.825 and press 1. You can also visit their online chat service for support 24/7.</li>
        </ul>
      </Typography>
    </Box>
  );
};
export default HurtingMyself;
